<script>
	import LineChart from "../LineChart/LineChart.svelte";
	import SingleBarChart from "../SingleBarChart/SingleBarChart.svelte";
	import { getBrightness, darken, rgbStringToHex } from "../utils";

	export let active;
	export let region;
	export let tooltipText;
	export let tooltipSubtitle = "";
	export let id;
	export let formatValue;
	export let colorScale;
	export let avgInRing;
	export let avgOutRing;
	export let totalValue;
	export let rank;
	export let color;
	export let barMaxValue;
	export let visType;
	export let avgBerlin;

	// const maxValue = colorScale.domain()[colorScale.domain().length - 1];
	const maxValue = barMaxValue;

	const ensureReadableOnWhite = (color) => {
		// Calculate the perceived brightness of the color.
		let brightness = getBrightness(color);

		if (brightness > 180) {
			const hex = color.startsWith("#") ? color : rgbStringToHex(color);
			let darkenedColor = darken(hex, 0.1); // you can adjust the amount to darken as needed
			return darkenedColor.toString();
		} else {
			return color;
		}
	};

	$: color = ensureReadableOnWhite(colorScale(region[id]));
	$: readableColor = ensureReadableOnWhite(color);
</script>

<div class="section vis-type-{visType}" {id} class:active style:border-left-color={active ? color : null} on:click>
	<div class="section__top">
		<div class="section__top__left">
			<div class="section__title">{@html tooltipText}</div>
		</div>
		<div class="section__top__right" style="--color: {readableColor}">
			{formatValue(region[id])}
		</div>
	</div>
	<div class="section__subtitle">{@html tooltipSubtitle}</div>
	<div class="section__content" id="section-{id}">
		{#if id === "change"}
			<div class:hidden={!region.noData} class="no-data">Keine Veränderung.</div>
			<div class="line-chart" class:hidden={region.noData}>
				<LineChart data={region} {colorScale} />
			</div>
		{:else}
			<SingleBarChart
				type={visType === "points" ? "triangle" : "bar"}
				{colorScale}
				currentColor={color}
				{maxValue}
				currentValue={region[id]}
				{formatValue}
				highlightedValues={[
					{ id: "berlin", value: avgBerlin, label: "⌀ Berlin", aligned: null },
					// { id: "in-ring", value: avgInRing, label: "⌀ Berlin im Ring", aligned: null },
					// { id: "out-ring", value: avgOutRing, label: "⌀ außerhalb Ring", aligned: null },
				]}
			/>
		{/if}
	</div>
</div>

<style lang="scss">
	.bar-triangle {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%;
		height: 50%;
		background: #fff;
		clip-path: polygon(0% 0%, 0% 100%, 100% 0%);

		&.bottom {
			clip-path: polygon(0% 0%, 0% 100%, 100% 100%);
			top: 51%;
		}
	}

	.hidden {
		display: none;
	}

	.section__content {
		position: relative;
		margin: 0px 10px;
	}

	.section {
		filter: grayscale(100%);
		opacity: 0.5;
		border-radius: 9px;
		padding: 8px 0;
		padding-left: 8px;
		padding-right: 8px;
		border-left: 3px solid transparent;
		margin-left: -10px;
		margin-right: -10px;
		transition: border-left-color 0.3s ease-in-out, filter 0.3s ease-in-out, opacity 0.3s ease-in-out;
		cursor: pointer;

		&.active {
			filter: none;
			opacity: 1;
			box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.15);
		}

		&__top {
			display: flex;
			justify-content: space-between;
			margin-bottom: 2px;

			&__right {
				font-weight: 600;
				font-size: 20px;
				line-height: 24px;
				text-align: right;
				color: var(--color);
			}

			&__left {
				align-self: flex-end;
			}
		}

		&__title {
			font-weight: 600;
			font-size: 13px;
			line-height: 120%;
			letter-spacing: 0.05em;
			text-transform: uppercase;
		}

		&__subtitle {
			font-weight: 400;
			font-size: 13px;
			line-height: 16px;
			color: #767676;
			margin-bottom: 19px;
		}

		&#change {
			.section__subtitle {
				margin-bottom: 8px;
				height: 54px;
			}
		}

		.no-data {
			color: #767676;
			font-size: 13px;
			height: 59px;
		}
	}
</style>
